import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// ----- Service Worker registration (Pass D2a) -----
// Skip in dev (CRA's dev server doesn't serve the SW reliably + HMR conflicts).
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // Quiet success — no logging in production console
        if (reg && reg.waiting) {
          // Force activation of new SW on next reload
          reg.waiting.postMessage({ type: "SKIP_WAITING" });
        }
      })
      .catch(() => {
        // Non-fatal: app continues to work without SW
      });
  });
}
